<template>
  <v-container class="px-0">
    <v-alert v-if="!proyectos.cargando && proyectos.paginas === 0" type="info" class="ma-12">
      <span class="body-1">{{ $t('sin_proyectos') }}&nbsp;</span>
      <v-btn color="primary" class="ml-4" depressed @click="goTo('proyecto-nuevo')">
        {{ $t('crear_proyecto') }}
      </v-btn>
    </v-alert>
    <div v-if="proyectos.cargando || proyectos.paginas > 0">
      <v-row no-gutters>
        <v-col cols="12">
          <v-toolbar color="transparent primary--text" flat>
            <v-toolbar-title class="font-weight-bold">{{ $tc('listado_proyectos', 2) | capitalize }}
            </v-toolbar-title>

            <div class="flex-grow-1"></div>

            <template>
              <v-btn icon color="primary" :disabled="proyectos.cargando" @click="cargarProyectos()">
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
              <v-btn icon color="primary" :disabled="proyectos.cargando" @click="goTo('proyecto-nuevo')">
                <v-icon>mdi-plus-circle</v-icon>
              </v-btn>
            </template>
          </v-toolbar>
          <v-progress-linear indeterminate :active="proyectos.cargando"/>
          <v-list>
            <div v-if="proyectos.cargando">
              <v-skeleton-loader v-for="i in proyectos.porPagina" :key="i"
                                 ref="skeleton"
                                 type="list-item-avatar-two-line"
                                 class="mx-auto"
              />
            </div>
            <div v-if="!proyectos.cargando">
              <v-list-item v-for="(proyecto,index) in proyectos.listado" :key="index" three-line>
                <v-avatar v-for="sc in proyecto.solucionesConstructivas" :key="sc.id">
                  <v-img :src="calcularMaterialImgSrc(proyecto.tipoSolCons, sc)"/>
                </v-avatar>

                <v-list-item-content class="ml-4">
                  <v-row no-gutters>
                    <v-col cols="9">
                      <v-list-item-title class="primary--text font-weight-bold">
                        {{ proyecto.nombre }}
                      </v-list-item-title>

                      <v-list-item-subtitle v-if="proyecto.solucionesConstructivas.length > 0">
                        {{ proyecto.tipoSolCons.nombre }}
                        &nbsp;-&nbsp;{{ tituloMaterial(proyecto.solucionesConstructivas[0]) }}
                        &nbsp;vs&nbsp;{{ tituloMaterial(proyecto.solucionesConstructivas[1]) }}
                        &nbsp;-&nbsp;{{ proyecto.created | formatDate }}
                      </v-list-item-subtitle>

                      <v-list-item-subtitle class="body-1 font-italic">
                        {{ proyecto.descripcion }}
                      </v-list-item-subtitle>
                    </v-col>

                  </v-row>
                </v-list-item-content>

                <v-list-item-action>
                  <v-row no-gutters>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-if="proyecto.solucionesConstructivas.length > 0" icon
                               @click="goTo('proyecto-detalles/'+proyecto.id)" v-bind="attrs" v-on="on">
                          <v-icon color="primary">mdi-eye</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $tc('ver') }}</span>
                    </v-tooltip>
                    <btn-compartir :id="proyecto.id" :titulo="$t('compartir_titulo')"
                                   :descripcion="$t('compartir_descripcion')" :peticion-compartir="peticionCompartir"/>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn @click="borrarProyecto(proyecto)" icon v-on="on">
                          <v-icon color="primary">mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </template>
                      <span class="text-capitalize">{{ $tc('borrar') }}</span>
                    </v-tooltip>
                  </v-row>
                </v-list-item-action>
              </v-list-item>
            </div>
          </v-list>

          <div class="text-center">
            <v-pagination
                circle
                v-model="proyectos.pagina"
                :length="proyectos.paginas"
                :disabled="proyectos.cargando"
            />
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import {VueRouteHelper} from "@/comunes/helpers/VueRouteHelper";
import ImagenesServicio from "@/comunes/servicios/ImagenesServicio";

import DescripcionesServicio from "@/comunes/servicios/DescripcionesServicio";
import BtnCompartir from "@/components/BtnCompartir";
import {MOSTRAR_DIALOGO_CONFIRMACION, MOSTRAR_SNACKBAR} from "@/store/store-app";

export default {
  name: 'ProyectoGuardadoPagina',
  components: {
    BtnCompartir
  },
  data: () => ({
    proyectos: {
      listado: [],
      cargando: false,
      pagina: 1,
      porPagina: 5,
      paginas: 0
    },
  }),
  mounted() {
    this.cargarProyectos();
  },
  watch: {
    'proyectos.pagina': function () {
      this.cargarProyectos();
    }
  },
  methods: {
    calcularMaterialImgSrc(tipSolCons, solCons) {
      if (solCons.materialPersonalizado) return solCons.materialPersonalizado.imagen;
      return ImagenesServicio.imgMaterial(tipSolCons.codigo, solCons.materialDermis.referencia);
    },
    tituloMaterial(solCons) {
      return DescripcionesServicio.materialSolCons(solCons);
    },
    goTo(path) {
      VueRouteHelper.goTo(path, this.$router);
    },
    cargarProyectos() {
      if (this.proyectos.cargando) return;

      this.proyectos.cargando = true;
      let params = {
        pagina: this.proyectos.pagina - 1,
        porPagina: this.proyectos.porPagina
      };

      HttpHelper.get('proyecto/listado', params)
          .then((res) => {
            this.proyectos.listado = res.content;
            this.proyectos.paginas = res.totalPages;
          })
          .finally(() => {
            this.proyectos.cargando = false;
          });
    },
    peticionCompartir(id) {
      return new Promise((resolve, reject) => {
        HttpHelper.get(`proyecto/${id}/compartir`)
            .then((response) => {
              resolve({url: `#/proyecto-detalles/${id}?clave-proyecto=${response.clave}`});
            })
            .catch(() => {
              reject();
            })
      });
    },
    borrarProyecto(proyecto) {
      this.$store.dispatch(MOSTRAR_DIALOGO_CONFIRMACION, {
        titulo: this.$t('borrar'),
        color: "warning",
        texto: this.$t('preg_borrar', {proyecto: proyecto.id + ' - ' + proyecto.nombre})
      }).then(() => {
        HttpHelper.get(`proyecto/${proyecto.id}/borrar`)
            .then(() => {
              this.$store.commit(MOSTRAR_SNACKBAR, {texto: this.$t('proy_borrado'), color: "success"});
              this.cargarProyectos();
            })
            .catch(() => {
              this.$store.commit(MOSTRAR_SNACKBAR, {texto: this.$t('proy_error'), color: "error"});
            });
      });
    }
  }
};
</script>

<style lang="scss">
.contenedor-principal {
  padding: 0;
}

.v-pagination {
  button {
    box-shadow: none !important;
  }
}
</style>

<style scoped lang="scss">
.v-alert.info {
  background-color: #f7d9cd !important;
  color: #40108e !important;

  .v-icon, .v-icon::before {
    color: #40108e !important;
    font-size: 30px !important;
    margin-top: 5px !important;
  }
}
</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "listado_proyectos": "Proyectos guardados",
    "sin_proyectos": "No tienes ningún proyecto, puedes crear uno pulsando el botón",
    "crear_proyecto": "Crear proyecto",
    "proyecto_borrado": "Proyecto borrado correctamente",
    "proyecto_copiado": "Proyecto copiado correctamente",
    "ver": "Ver",
    "compartir_titulo": "Compartir proyecto",
    "compartir_descripcion": "Cualquier persona con este enlace puede visualizar este proyecto",
    "preg_borrar": "¿Estás seguro de que quieres borrar el proyecto <span class='font-weight-bold'>{proyecto}</span>?",
    "proy_borrado": "El proyecto ha sido borrado",
    "proy_error": "No se ha podido borrar el proyecto"
  }
}
</i18n>
<!--@formatter:on-->
